module.exports = __webpack_public_path__ + "img/bg_homepage.6a101319.png";